/**
 * 编辑视图模块路由
 */
export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "market",
        component: resolve => require(["@/views/market/index.vue"], resolve),
        children: [
          {
            path: "weixin",
            component: resolve => require(["@/modules/weixin/pages/index.vue"], resolve)
          },
          {
            path: "weixin/:id",
            component: resolve => require(["@/modules/weixin/pages/manage/index.vue"], resolve),
            redirect: "weixin/:id/drafts",
            children: [
              {
                path: "publish",
                name: "wxPublish",
                meta: {
                  nameText: "发表记录"
                },
                component: () => import("@/modules/weixin/pages/manage/message.vue")
              },
              {
                path: "messageTemplate",
                name: "wxMessageTemplate",
                meta: {
                  nameText: "模板消息"
                },
                component: () => import("@/modules/weixin/pages/manage/MessageTemplate.vue")
              },
              {
                path: "addSend",
                name: "addSend",
                meta: {
                  nameText: "新建群发"
                },
                component: () => import("@/modules/weixin/pages/manage/AddSend.vue")
              },
              {
                path: "wechatSend",
                name: "wechatSend",
                meta: {
                  nameText: "微信群发"
                },
                component: () => import("@/modules/weixin/pages/manage/WechatSend.vue")
              },
              {
                path: "material/article",
                name: "wxMaterialArticle",
                meta: {
                  nameText: "图文素材"
                },
                component: () => import("@/modules/weixin/pages/manage/material/article.vue")
              },
              {
                path: "material/image",
                name: "wxMaterialImage",
                meta: {
                  nameText: "图片素材"
                },
                component: () => import("@/modules/weixin/pages/manage/material/image.vue")
              },
              {
                path: "materialAdd/:mid",
                name: "wxMaterialAdd",
                meta: {
                  nameText: "新建素材"
                },
                component: () => import("@/modules/weixin/pages/manage/material/article-add.vue")
              },
              {
                path: "user",
                name: "wxUser",
                meta: {
                  nameText: "粉丝管理"
                },
                component: () => import("@/modules/weixin/pages/manage/user.vue")
              },
              {
                path: "drafts",
                name: "wxDrafts",
                meta: {
                  nameText: "草稿箱"
                },
                component: () => import("@/modules/weixin/pages/manage/drafts.vue")
              },
              {
                path: "marketSet",
                name: "wxMarketSet",
                meta: {
                  nameText: "营销设置"
                },
                component: () => import("@/modules/weixin/pages/manage/MarketSet.vue")
              },
            ]
          }
        ]
      }
    ]
  }
];

